export default "/videos/5c6f1a0e10d22860d82a6a3d86c666be.mp4";